<template>
  <div class="row bg-primary-02">
    <div class="col mt-3">

    <div class="row bg-grey-01">
      <div class="col mt-3 mb-3">
        <span class="">Username &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <input type="text" v-model="username"/>
      </div>

      <div class="col mt-3 mb-3">
        <span class="">User Role</span>
        <select v-model="role">
          <option v-bind:value="3">Normal</option>
          <option v-bind:value="2">Admin</option>
        </select>
        <button type="button" @click="saveUser()" class="btn btn-dark ml-3">Save Edit</button>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col">
        <span class="text-orange-10">New Password </span>
        <input type="password" v-model="password"/>
        <button type="button" @click="changePassword(userId)" class="btn btn-dark ml-3">Change Password</button>
      </div>
    </div>

    <div class="row">
      <div class="col-8 mb-3">
        <button type="button" @click="deleteUserCheck(userId)"class="btn btn-danger">Delete User</button>
      </div>
    </div>

    <!-- modal window for verifying user deletion -->
    <modal-window
    text-value="Delete this user?" 
    v-show="saveOpened"
    v-on:close-modal="closeSaveModal"
    v-on:yes-click="deleteUser(userId)"></modal-window>
  
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import ModalWindow from '@/components/display-utils/ModalWindow.vue'

export default {
  data () {
    return {
      username: "",
      password: "",
      role: "",
      saveOpened: false
    }
  },
  components: {
    ModalWindow
  },
  props:['userId'],
  mounted: function() {
    this.getData()
  },
  watch: {
    userId: function() {
      this.getData()
    }
  },
  methods: {
    getData: function() {
      let local = this
      let userId = this.userId

      //make sure we're passing an int
      if (userId % 1 === 0) {
        //ajax query
        axios({
            method: 'get',
            url: local.$helpers.api() + '/admin/user/' + userId,
            data: userId,
            headers: {'X-Requested-With': 'XMLHttpRequest',
                      'Content-Type': 'application/json',
                      'User-Token': local.$helpers.getToken()}
          })
          .then(function (response) {
            local.populateUser(response.data)
          })
          .catch(function (error) {
            console.log("not logged in: ", error)
          });
      }
    },

    populateUser: function(data) {
      //this.creds.username = data.username
      this.username= data.username
      this.role = data.role
    },
    saveUser: function() {
      let local = this
      let creds = {}
      creds.id = this.userId
      creds.username = this.username
      creds.role = this.role

      //ajax query
      axios({
          method: 'post',
          url: local.$helpers.api() + '/admin/user/update',
          data: creds,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //refresh user data
          local.getData()
          local.$emit("userRefresh", "")
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
        });
    },

    deleteUserCheck: function() {
      //open modal window to verify action
      this.saveOpened = true
    },

    deleteUser: function(id) {
      let local = this
      let creds = {}
      creds.id = id

      //make sure we're passing an int
      if (id % 1 === 0) {
        //ajax query
        axios({
            method: 'post',
            url: local.$helpers.api() + '/admin/user/delete',
            data: creds,
            headers: {'X-Requested-With': 'XMLHttpRequest',
                      'Content-Type': 'application/json',
                      'User-Token': local.$helpers.getToken()}
          })
          .then(function (response) {
            //send data up to parent component
            local.$emit("userRefresh", "")

            //clear form
            local.clearEditForm()
          })
          .catch(function (error) {
            console.log("not logged in: ", error)
          });
      }
    },

    changePassword: function(id) {
      let local = this
      let creds = {}
      creds.id = id
      creds.password = this.password

      //make sure we're passing an int
      if (id % 1 === 0) {
        //ajax query
        axios({
            method: 'post',
            url: local.$helpers.api() + '/admin/user/password',
            data: creds,
            headers: {'X-Requested-With': 'XMLHttpRequest',
                      'Content-Type': 'application/json',
                      'User-Token': local.$helpers.getToken()}
          })
          .then(function (response) {
            //send data up to parent component
            local.$emit("userRefresh", "")

            //clear form
            local.clearEditForm()
          })
          .catch(function (error) {
            console.log("not logged in: ", error)
          });
      }
    },
    clearEditForm: function() {
      this.username = ""
      this.password = ""
      this.role = ""
      //this.userId = undefined
    },
    closeSaveModal: function() {
      this.saveOpened = false
    }
  }
}
</script>

<style>
</style>
